<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.editing' | translate }}
    v-card-content
      template(v-if="!isLocked")
        v-text-field.mb-3(
          :focus="true"
          :label="'base.name'| translate"
          v-model="payload.name")
        v-select.mb-3(
          :label="'base.recipe'| translate"
          item-name="ingredient_name"
          item-value="id"
          :options="recipesList"
          v-model="payload.schedule_animalfeed_recipe.animalfeed_recipe")
      v-date-field.mb-3(
        :label="'base.date'| translate"
        :min-date="new Date().toISOString().slice(0, 10)"
        v-model="plannedOnDate")
      v-switch.mb-3(
        :label="'base.planing_on_nex_day'| translate"
        v-model="payload.auto_planning")
      template(v-if="!isLocked")
        v-text-field.mb-3(
          :label="'base.mixing_mass'| translate"
          v-model="payload.plan_weight")
        ui-number-input(
          :label="'base.mix_time'| translate"
          :postfix="'base.min'| translate"
          v-model="payload.mix_time")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        @click="onEdit") {{ 'base.save' | translate }}
      v-btn.mr-2.delete-btn(
        v-if="this.status === 'waited'"
        :loading="loading"
        danger
        @click="onDelete") {{ 'base.delete' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { formateDateString } from '@/util'

import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput'

export default {
  name: 'EditPlanningModal',

  components: {
    UiNumberInput
  },

  mounted () {
    const params = {
      farm: this.$route.params.farm_id
    }
    this.loadRecipesList(params)
    this.payload.farm = this.currentSchedule.farm
    this.payload.name = this.currentSchedule.name
    this.payload.plan_weight = this.currentSchedule.plan_weight
    this.payload.schedule_animalfeed_recipe.animalfeed_recipe = this.currentSchedule.schedule_animalfeed_recipe &&
    this.currentSchedule.schedule_animalfeed_recipe.animalfeed_recipe
    this.payload.mix_time = this.currentSchedule.mix_time
    this.payload.auto_planning = this.currentSchedule.auto_planning
    this.status = this.currentSchedule.status

    this.plannedOnDate = formateDateString(this.currentSchedule.planned_on)
  },

  data: () => ({
    payload: {
      farm: 0,
      name: null,
      animalfeed_recipe: null,
      planned_on: null,
      schedule_animalfeed_recipe: {
        animalfeed_recipe: null
      },
      mix_time: 10,
      plan_weight: null,
      auto_planning: false
    },
    status: null,
    loading: false,
    plannedOnDate: null,
  }),

  computed: {
    ...mapGetters('animalfeed', [
      'currentSchedule'
    ]),

    ...mapGetters('recipes', [
      'recipesList'
    ]),

    isLocked () {
      return this.status !== 'waited'
    }
  },

  methods: {
    ...mapActions('recipes', [
      'loadRecipesList'
    ]),

    ...mapActions('animalfeed', [
      'updateSchedule',
      'deleteSchedule',
      'loadSchedule'
    ]),

    async onEdit () {
      const id = this.currentSchedule.id
      this.loading = true
      this.payload.planned_on = `${this.plannedOnDate}T15:00:00.817Z`
      await this.updateSchedule({ id: id, payload: this.payload })
      this.loading = false
      this.$emit('close')
    },

    async onDelete () {
      const id = this.currentSchedule.id
      this.loading = true
      await this.deleteSchedule({ id: id })
      this.loading = false
      await this.onLoad()
      // this.$emit('close')
    },

    async onLoad () {
      const id = this.currentSchedule.id
      const payload = {
        plan_weight: 1000,
        schedule_mixer: {
          mixer: 18
        }
      }
      await this.loadSchedule({ id, payload })
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss">
.delete-btn{
  float: right;
  padding-top: 10px;
  //color: red;
}
</style>
